
const ProgressBar = ({ progress = 0 }) => (
    <div className="progressBar">
        <div className="progress" style={{ width: `${progress}%` }} />
    </div>
);
export default ProgressBar;
